<template>
<button class="btn bg-transparent p-0" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom" aria-controls="offcanvasBottom"><img id="infoImg" src="https://radap.ir/imagesUploaded/other/info.png" width="20"> </button>

<div class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasBottom" aria-labelledby="offcanvasBottomLabel">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title text-dark" id="offcanvasBottomLabel" style="display: flex;align-items: flex-end;font-weight: 700;"><img src="https://radap.ir/imagesUploaded/other/wallet.png" width="50">با راداَپ درآمد داشته باش!</h5>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body small text-dark">
    <div>
     زمانی که در راداَپ ثبت نام میکنید سیستم کسب درآمد برای شما فعال میشه. 
    </div>
    <div>
     با هر خرید از راداَپ میتونید در همین قسمت مشاهده کنید که باتوجه به مبلغ صورتحساب شما چه مقدار برای کسی که معرفیتون کرده سود پرداخت میشه و حالا اگه دوست دارید درآمد داشته باشید کافیه کد معرف خودتون رو از قسمت کسب درآمد برای عزیزانتون به اشتراک بگذارید و باخرید اون ها از راداَپ اعتبار دریافت کنید و در خریدهای بعدی پول کمتری بپردازید. 
    </div>
    <button class="btn btn-outline-success text-dark w-100 mt-1" type="button" data-bs-dismiss="offcanvas">متوجه شدم</button>
  </div>
</div>
</template>
<script setup>
import { onMounted,onUnmounted } from 'vue';
let benefitInterval;
onMounted(() => {
  
  benefitInterval = setInterval(() => {
    if(document.getElementById('infoImg').style.opacity == .2){
      document.getElementById('infoImg').style.opacity = 1
    }else{
      document.getElementById('infoImg').style.opacity = .2
    }
  }, 1000);
})
onUnmounted(() => {
  clearInterval(benefitInterval)
})
</script>
<style>

.offcanvas.offcanvas-bottom {
    left: 0;
    right: 0;
    height: auto;
}

.offcanvas-backdrop {
    background-color: transparent !important;
}
</style>